"use client"

import { Suspense } from "react"
import TestDrivePopup from "./TestDrivePopup"

export default function TestDrivePopupWrapper(props: any) {
  return (
    <Suspense fallback={null}>
      <TestDrivePopup {...props} />
    </Suspense>
  )
}
